import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableCell, TableContainer, TableRow, TextareaAutosize, Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectCuttingDatalist } from '../Selectors/Master/ItemSelectors';
import { UpdateCuttingEntry } from '../../Store/PHPSlice/Cutting/clothIssue';
import { errorStyles } from '../../Utils/table';
import { useParams } from 'react-router-dom';
import { fetchCuttingList } from '../../Store/PHPSlice/Cutting/cuttingApi';


const CuttingInEdit = () => {

    const { Id } = useParams();
    const [formData, setFormData] = useState({
        cutId: parseInt(Id),
        dt: getCurrentDate(),
        ordType: '',
        ordValue: '',
        memo: '',
        sono: '0',
        empType: '',//Inhouse
        master: '',
        mcloth: '',
        mgMtr: '',
        mrqMtr: '',
        totQty: '',
        userId: '1',
        item: '',
        noofmatch: '',
        mId: '',
        m1Id: '',
        m2Id: '',
        m3Id: '',
        mtch1: '',
        mtch2: '',
        mtch3: '',
        m1rqMtr: '',
        m2rqMtr: '',
        m3rqMtr: '',
        m1gMtr: '',
        m2gMtr: '',
        m3gMtr: '',
        instructions: '',
        soId: '',
    });

    const [errors, setErrors] = useState({});
    const [cuttingInfo, setCuttingInfo] = useState([]);
    const dispatch = useDispatch();

    const cuttinglist = useSelector(selectCuttingDatalist);
    useEffect(() => {
        dispatch(fetchCuttingList(Id));
    }, [dispatch, Id]);

    // console.log(cuttinglist)
    useEffect(() => {
        if (cuttinglist.data.length > 0) {
            const value = cuttinglist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: value.dt,
                memo: value.memoNo,
                ordType: value.ordType,
                ordValue: value.ordTypeValue,
                master: value.empNm,
                soId: value.soId,
                sono: value.sono,
                item: value.itemNm,
                totQty: value.totQty,
                empType: value.empType
            }))
        }
        if (cuttinglist.cuttingCloths.length > 0) {
            const value = cuttinglist.cuttingCloths[0];
            setFormData(prev => ({
                ...prev,
                mId: value.mcloth,
                mcloth: value.mclothNm,
                mgMtr: value.mgmtr,
                mrqMtr: value.mreq,
                m1Id: value.m1cloth,
                mtch1: value.m1clothNm,
                m1gMtr: value.m1gMtr,
                m1rqMtr: value.m1req,
                m2Id: value.m2cloth,
                mtch2: value.m2clothNm,
                m2gMtr: value.m2gmtr,
                m2rqMtr: value.m2req,
                m3Id: value.m3cloth,
                mtch3: value.m3clothNm,
                m3gMtr: value.m3gmtr,
                m3rqMtr: value.m3req,
                instructions: value.instruction,
            }))
        }
        if (cuttinglist.cuttingInfo.length > 0) {
            const value = cuttinglist.cuttingInfo;
            setCuttingInfo(value);
        }
    }, [cuttinglist]);

    useEffect(() => {
        if (cuttingInfo) {
            const totalQty = cuttingInfo?.reduce((sum, num) => sum + parseFloat(num.qty), 0);
            const mreq = cuttingInfo?.map((item, index) => parseFloat(item.mavg) * parseFloat(cuttingInfo[index]?.qty));
            const tot_mreq = mreq.reduce((acc, num) => acc + num, 0);
            const m1req = cuttingInfo?.map((item, index) => parseFloat(item.m1avg) * parseFloat(cuttingInfo[index]?.qty));
            const tot_m1req = m1req.reduce((acc, num) => acc + num, 0);
            const m2req = cuttingInfo?.map((item, index) => parseFloat(item.m2avg) * parseFloat(cuttingInfo[index]?.qty));
            const tot_m2req = m2req.reduce((acc, num) => acc + num, 0);
            const m3req = cuttingInfo?.map((item, index) => parseFloat(item.m3avg) * parseFloat(cuttingInfo[index]?.qty));
            const tot_m3req = m3req.reduce((acc, num) => acc + num, 0);
            setFormData(prev => ({
                ...prev,
                totQty: totalQty.toFixed(2),
                mrqMtr: tot_mreq.toFixed(2),
                m1rqMtr: tot_m1req.toFixed(2),
                m2rqMtr: tot_m2req.toFixed(2),
                m3rqMtr: tot_m3req.toFixed(2),
            }));
        }
    }, [cuttingInfo]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleCuttingInfoChange = (index, field, value) => {
        const soId = formData.soId; // Get soId from formData
        const soQty = cuttingInfo[index]?.soqty; // Get soqty for the specific item

        // Allow empty input or only numbers
        if (value === '' || !isNaN(value)) {
            if (soId !== '0' && parseInt(value) > soQty) {
                alert(`Quantity cannot exceed SO qty of ${soQty}.`);
                return; // Prevent state update
            }

            setCuttingInfo(prevCuttingInfo => {
                const updatedCuttingInfo = [...prevCuttingInfo];
                updatedCuttingInfo[index] = {
                    ...updatedCuttingInfo[index],
                    [field]: value,
                };
                return updatedCuttingInfo;
            });
        }


    };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function convertOneObject(formData, cuttingInfo) {
        const data = {
            dt: formData.dt,
            cutId: formData.cutId,
            instruction: formData.instructions,
            totQty: formData.totQty,
            mreq: formData.mrqMtr,
            m1req: formData.m1rqMtr,
            m2req: formData.m2rqMtr,
            m3req: formData.m3rqMtr,
            size: cuttingInfo?.map(item => item.size),
            qty: cuttingInfo?.map(item => item.qty),
        }
        return data;
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const finalObj = convertOneObject(formData, cuttingInfo);

        dispatch(UpdateCuttingEntry(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Cutting Updated");
                // window.location.reload();
                alert("Cutting Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>

            <div style={{ margin: '1% 1%' }}>
                <h2 style={{ textAlign: 'center' }}>{formData.empType === '1' ? 'Cutting Entry(In-House) Edit' : 'Contractor Cutting Edit'}</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='ordType'>Order Type:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='ordType'

                                                >
                                                    {formData.ordType || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {formData.ordValue === '1' &&
                                    <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor='sono'>Sale Order No.:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {/* Replace TextField with Typography to display plain text */}
                                                    <Typography
                                                        id='sono'

                                                    >
                                                        {formData.sono || ''} {/* Display value or fallback to 'N/A' */}
                                                    </Typography>

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }


                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='master'>Master Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='master'

                                                >
                                                    {formData.master || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='memo'>Memo No.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='memo'

                                                >
                                                    {formData.memo || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mcloth'>Main Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mcloth'

                                                >
                                                    {formData.mcloth || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='item'>Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='item'

                                                >
                                                    {formData.item || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mgMtr'>Main Given Mtr.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mgMtr'

                                                >
                                                    {formData.mgMtr || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='mrqMtr'>Main Required Mtr.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='mrqMtr'

                                                >
                                                    {formData.mrqMtr || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='totQty'>Main Total Qty.:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                {/* Replace TextField with Typography to display plain text */}
                                                <Typography
                                                    id='totQty'

                                                >
                                                    {formData.totQty || ''} {/* Display value or fallback to 'N/A' */}
                                                </Typography>

                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {formData.m1Id !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='mtch1'>Matching-1 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='mtch1'

                                                        >
                                                            {formData.mtch1 || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m1rqMtr'>Match-1 Req Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m1rqMtr'

                                                        >
                                                            {formData.m1rqMtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                }

                                {formData.m2Id !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='mtch2'>Matching-2 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='mtch2'

                                                        >
                                                            {formData.mtch2 || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m2rqMtr'>Match-2 Req Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m2rqMtr'

                                                        >
                                                            {formData.m2rqMtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                }

                                {formData.m3Id !== '0' &&
                                    <>
                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='mtch3'>Matching-3 Cloth:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='mtch3'

                                                        >
                                                            {formData.mtch3 || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} md={6} sx={{ mt: 0.6 }}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor='m3rqMtr'>Match-3 Req Mtr.:</InputLabel>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth>
                                                        {/* Replace TextField with Typography to display plain text */}
                                                        <Typography
                                                            id='m3rqMtr'

                                                        >
                                                            {formData.m3rqMtr || ''} {/* Display value or fallback to 'N/A' */}
                                                        </Typography>

                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </>
                                }


                                {cuttingInfo.length > 0 &&
                                    (<Grid item xs={10} md={11}>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    {cuttingInfo.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                    ))}

                                                </TableRow>

                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Main Avg.</TableCell>
                                                    {cuttingInfo.map((item, index) => (
                                                        <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.mavg}</TableCell>
                                                    ))}

                                                </TableRow>
                                                {formData.m1Id !== '0' &&
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Match-1 Avg.</TableCell>
                                                        {cuttingInfo.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m1avg}</TableCell>
                                                        ))}

                                                    </TableRow>
                                                }
                                                {formData.m2Id !== '0' &&
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Match-1 Avg.</TableCell>
                                                        {cuttingInfo.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m2avg}</TableCell>
                                                        ))}

                                                    </TableRow>
                                                }
                                                {formData.m3Id !== '0' &&
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Match-1 Avg.</TableCell>
                                                        {cuttingInfo.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.m3avg}</TableCell>
                                                        ))}

                                                    </TableRow>
                                                }
                                                {formData.soId !== '0' &&
                                                    <TableRow>
                                                        <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>SO qty.</TableCell>
                                                        {cuttingInfo.map((item, index) => (
                                                            <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.soqty}</TableCell>
                                                        ))}

                                                    </TableRow>
                                                }
                                                <TableRow>
                                                    <TableCell className='tbl-row' sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty.</TableCell>
                                                    {cuttingInfo.map((item, index) => (
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <input
                                                                type="text"
                                                                value={item.qty}
                                                                onChange={(e) => handleCuttingInfoChange(index, 'qty', e.target.value)}
                                                                style={{ width: '40px', padding: '1px' }}
                                                            />
                                                        </TableCell>

                                                    ))}

                                                </TableRow>

                                            </Table>
                                        </TableContainer>
                                    </Grid>)
                                }

                                {[
                                    { label: 'Cutting Instructions', name: 'instructions' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        style={{ ...styled.input, width: '100%' }}
                                                        readOnly={field.type === 'readOnly'}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid >
            </div >
        </>
    );
}

export default CuttingInEdit;
